import partQueries from "$/lib/queries/part-queries"
import upsellQueries from "$/lib/queries/upsell-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/upsell")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(upsellQueries.categories())
    queryClient.prefetchQuery(partQueries.adminList())
    return { crumb: "Tillval" }
  },
})
